<template>
    <div class="member-pay">
        <!-- 顶部导航 -->
        <div class="header-tab">
            <div :class="{ 'active': activeType == 'vip' }" @click="switchTab('vip')">会员开通记录</div>
            <div :class="{ 'active': activeType == 'code' }" @click="switchTab('code')">兑换码兑换记录</div>
        </div>

        <!-- VIP开通记录 -->
        <el-scrollbar v-show="activeType == 'vip'" ref="vipScrollbarRef" height="calc(100vh - 3.5rem)" @end-reached="loadMoreVip">
            <div v-if="vipList.length == 0" class="no-data">
                还没有会员开通记录～
            </div>
            <div class="history-list" v-else>
                <div class="history-item" v-for="item in vipList" :key="item.activateDate">
                    <div class="title">{{ item.title }}</div>
                    <div class="info">
                        <div class="item">到期时间：{{ item.expireDate }}</div>
                        <div class="item">开通时间：{{ item.activateDate }}</div>
                        <div class="item">来源：{{ item.origin }}</div>
                    </div>
                    <div v-if="item.days" class="days">{{ item.days }}</div>
                </div>
            </div>
        </el-scrollbar>

        <!-- 兑换码兑换记录 -->
        <el-scrollbar v-show="activeType == 'code'" ref="codeScrollbarRef" height="calc(100vh - 3.5rem)" @end-reached="loadMoreCode">
            <div v-if="codeList.length == 0" class="no-data">
                还没有兑换记录～
            </div>
            <div class="history-list" v-else>
                <div class="history-item" v-for="item in codeList" :key="item.activateDate">
                    <div class="title">{{ item.title }}</div>
                    <div class="info">
                        <div class="item">到期时间：{{ item.expireDate }}</div>
                        <div class="item">开通时间：{{ item.activateDate }}</div>
                        <div class="item">来源：{{ item.origin }}</div>
                    </div>
                    <div v-if="item.days" class="days">{{ item.days }}</div>
                </div>
            </div>
        </el-scrollbar>
    </div>
</template>

<script setup>
import { ref, nextTick, onMounted, onUnmounted, getCurrentInstance } from 'vue';
import { getVipRecord } from '@/api/vip.js';
import wk from "@/utils/jsBridge.js";

const userId = ref("");
const { proxy } = getCurrentInstance();
const classType = ref("3");
const activeType = ref("vip");
const vipScrollbarRef = ref(null);
const codeScrollbarRef = ref(null);

// VIP开通记录
const vipList = ref([]);
const vipPageNum = ref(1);
const vipIsAll = ref(false);

// 兑换码兑换记录
const codeList = ref([]);
const codePageNum = ref(1);
const codeIsAll = ref(false);
const codeLoaded = ref(false);

const pageSize = 10;

const switchTab = (type) => {
    if (activeType.value === type) return;
    activeType.value = type;
    if (type === 'code' && !codeLoaded.value) {
        getCodeHistory();
    }
    // 切换后重置对应滚动条到顶部
    nextTick(() => {
        if (type === 'vip' && vipScrollbarRef.value) {
            vipScrollbarRef.value.setScrollTop(0);
        } else if (type === 'code' && codeScrollbarRef.value) {
            codeScrollbarRef.value.setScrollTop(0);
        }
    });
}

const loadMoreVip = () => {
    if (vipIsAll.value || vipList.value.length == 0) return;
    vipPageNum.value++;
    getVipHistory();
}

const loadMoreCode = () => {
    if (codeIsAll.value || codeList.value.length == 0) return;
    codePageNum.value++;
    getCodeHistory();
}

const getVipHistory = () => {
    getVipRecord({
        "userId": userId.value,
        "productType": classType.value == 3 ? "IELTS" : "TOEFL",
        "pageNum": vipPageNum.value,
        "recordType": "ACTIVATE",
        "pageSize": pageSize
    }).then(res => {
        if (res.data.list) {
            vipList.value = vipList.value.concat(res.data.list);
            vipIsAll.value = !(res.data.list.length < res.data.total);
        }
    });
}

const getCodeHistory = () => {
    getVipRecord({
        "userId": userId.value,
        "productType": classType.value == 3 ? "IELTS" : "TOEFL",
        "pageNum": codePageNum.value,
        "recordType": "REDEEM",
        "pageSize": pageSize
    }).then(res => {
        if (res.data.list) {
            codeList.value = codeList.value.concat(res.data.list);
            codeIsAll.value = !(res.data.list.length < res.data.total);
        }
        codeLoaded.value = true;
    });
}

onMounted(() => {
    wk.init(() => {
        let query = proxy.$router.currentRoute.value.query;
        userId.value = query.pp_id || query.ppid || query.userId || "";
        classType.value = query.classType || "3";
        if (wk.isApp) {
            userId.value = wk.getPpId();
            classType.value = wk.getClassType();
        }
        getVipHistory();
    })
});

onUnmounted(() => {

});
</script>

<style lang="less" scoped>
.header-tab {
    display: flex;
    margin-bottom: 0.75rem;
    padding: 0.75rem;
    align-items: center;
    background-color: #fff;
    height: 2.75rem;

    >div {
        width: 50%;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 0.88rem;
        color: #666B6F;
        text-align: center;
        position: relative;
        transition: all 0.2s;

        &.active {
            font-size: 1rem;
            color: #2F2F2F;

            &::after {
                position: absolute;
                content: '';
                width: 1.25rem;
                height: 0.25rem;
                background: #FF6D01;
                border-radius: 0.25rem;
                left: 50%;
                bottom: -0.75rem;
                transform: translateX(-50%);
            }
        }
    }
}

.member-pay {
    min-height: 100vh;
    background-color: #F8F9FD;
    overflow: hidden;
    box-sizing: border-box;

    div {
        box-sizing: border-box;
    }

    .header {
        position: fixed;
        width: 100%;
        height: 4.5rem;
        padding-top: 2.5rem;
        top: 0;
        left: 0;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 1.13rem;
        color: #000;
        z-index: 100;
        text-align: center;
        background-color: #fff;
        display: flex;
        justify-content: center;

        .back-btn {
            position: absolute;
            left: 1rem;
            top: 2.8rem;
            font-size: 1rem;
        }
    }

    .history-list {
        padding: 0.75rem 1rem;

        .history-item {
            background: #FFFFFF;
            border-radius: 0.75rem;
            margin-bottom: 0.75rem;
            padding: 0.75rem 1rem;
            position: relative;
            overflow: hidden;

            .title {
                font-family: PingFangSC-Medium;
                font-weight: 500;
                font-size: 1rem;
                color: #2F2F2F;
            }

            .days {
                position: absolute;
                top: -1.2rem;
                right: -2.2rem;
                width: 5.5rem;
                height: 3.88rem;
                background-image: linear-gradient(114deg, #F9E3C1 0%, #F9E5C9 48%, #EFCFA2 94%);
                transform: rotate(45deg);
                text-align: center;
                padding-top: 2.25rem;
                font-family: PingFangSC-Medium;
                font-weight: bold;
                font-size: 1rem;
                color: #402418;
            }

            .info {
                margin-top: 0.5rem;

                .item {
                    font-family: PingFangSC-Regular;
                    font-weight: 400;
                    font-size: 0.88rem;
                    color: #666666;
                    margin-bottom: 0.25rem;

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
}

.no-data {
    margin-top: 30%;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 0.81rem;
    color: #666666;
    text-align: center;

    &::before {
        content: '';
        display: block;
        width: 6.5rem;
        height: 7.38rem;
        background: url(https://cdntiku.oss-cn-shanghai.aliyuncs.com/h5/vip/order/empty.png) no-repeat;
        background-size: 100%;
        margin: 0 auto 1rem;
    }
}
</style>
